"use client";

import DOMPurify from "dompurify";
import { memo } from "react";

/** Allowed tags for form field labels (basic inline formatting only) */
export const LABEL_ALLOWED_TAGS = ["b", "strong", "em", "i", "u", "a", "br", "span"];

/**
 * Renders a form field label (which may contain basic inline HTML formatting)
 * with sanitized `dangerouslySetInnerHTML`, so labels display consistently —
 * bold/italic/links rendered, not shown as literal markup — everywhere a field
 * label appears (the live form and the already-submitted recap alike).
 *
 * @param props.html - The label's raw HTML content.
 * @param props.className - Optional wrapper class.
 * @returns Sanitized label element.
 */
export const HtmlLabel = memo(
  ({ html, className }: { html: string; className?: string }): JSX.Element => (
    <span
      className={className}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html, { ALLOWED_TAGS: LABEL_ALLOWED_TAGS }) }}
    />
  )
);
HtmlLabel.displayName = "HtmlLabel";
